import { Stack, SxProps, Typography } from "@mui/material";

interface Props {
  label: string;
  value?: string | React.ReactNode;
  vertical?: boolean;
  emptyMessage?: string;
  sx?: SxProps;
  fontSize?: number | string;
}

const DataCell = ({ label, value, vertical = false, emptyMessage = "N/A", sx, fontSize }: Props) => {
  return (
    <Stack className="data-cell" spacing={vertical ? 0 : 2} direction={vertical ? "column" : "row"} sx={sx} justifyContent={"space-between"}>
      <Typography variant="body1" color="textSecondary" fontSize={fontSize}>
        {label}
      </Typography>
      <Typography textAlign={vertical ? "left" : "right"} variant="body2" fontSize={fontSize}>
        {value ?? emptyMessage}
      </Typography>
    </Stack>
  );
};

export default DataCell;
